export default "__VITE_ASSET__098412bc__"